import { Col, Row } from 'antd'
import { ArcElement, CategoryScale, Legend, Tooltip } from 'chart.js'
import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { CardRow } from 'modules/Roles/Style/style'
import React, { useEffect, useState } from 'react'
import { Bar, Doughnut } from 'react-chartjs-2'
import {
  AlertText,
  AnswerDiv,
  AnswerOptionBackground,
  AnswerOptions,
  ChartCard,
  DoughnutChartAlign,
  EmptyMessage,
  IndividualCard,
  IndividualCardContainer,
  NoteMessage,
  Question,
  QuestionDiv,
  SeeMore,
  StyledInfoCircle,
  StyledSpace,
} from '../../../../ViewRole/Header/QuestionaireDashboard/IndividualPage/Style/style'
import { OverViewText } from '../OverViewpage/style'
import QuestionWithSeeMore from './Partials/QuestionDrawer'
Chart.register(ChartDataLabels)
Chart.register(ArcElement, Tooltip, Legend, CategoryScale)

function Individualindex({
  graphList,
  individualDrawerQuestion,
  getIndividualDrawerList,
  jobId,
  singleRoleData,
  getCandidateDetails,
  getPromotion,
  promotionData,
  candidateDetails,
  getQuestionAndAnswerList,
  isVisible = false,
  setCountDriveSummary,
  countDriveSummary,
}) {
  const [chartData, setChartData] = useState([])
  const [tooltip, setTooltip] = useState('')
  const [clear, setClear] = useState(false)
  const [drawerVisible, setDrawerVisible] = useState(false)
  const [questionToDisplay, setQuestionToDisplay] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [questionId, setQuestionId] = useState('')
  const [pageNum, setPageNum] = useState(1)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (graphList?.length > 0) {
      const updatedData = graphList.map(item => {
        const chartData = {
          labels: [],
          data: [],
          percentage: [],
          backgroundColor: [],
          borderColor: [],
        }

        if (item.correctCount > 0) {
          chartData.labels.push('Correct')
          chartData.data.push(item.correctCount)
          chartData.percentage.push(
            item.percentages.correctPercentage?.toFixed(2)
          )
          chartData.backgroundColor.push('#0FB680')
          chartData.borderColor.push('#0FB680')
        }

        if (item.inCorrectCount > 0) {
          chartData.labels.push('Incorrect')
          chartData.data.push(item.inCorrectCount)
          chartData.percentage.push(
            item.percentages.incorrectPercentage?.toFixed(2)
          )
          chartData.backgroundColor.push('#F54B56')
          chartData.borderColor.push('#F54B56')
        }

        if (item.NACount > 0) {
          chartData.labels.push('NA')
          chartData.data.push(item.NACount)
          chartData.percentage.push(item.percentages.NAPercentage?.toFixed(2))
          chartData.backgroundColor.push('#7F7F7F')
          chartData.borderColor.push('#7F7F7F')
        }

        return { ...item, chart: chartData }
      })
      setChartData(updatedData)
    }
  }, [graphList])
  const LabelChange = label => {
    let data = { toShow: '', color: '', status: '' }
    if (label == 'Correct') {
      let finalData = {
        ...data,
        toShow: 'Answered Correctly',
        color: '#0FB680',
        status: 'CORRECT',
      }
      return finalData
    } else if (label == 'Incorrect') {
      let finalData = {
        ...data,
        toShow: 'Answered Incorrectly',
        color: '#F54B56',
        status: 'INCORRECT',
      }
      return finalData
    } else {
      let finalData = {
        ...data,
        toShow: 'Not Answered',
        color: '#7F7F7F',
        status: 'NA',
      }
      return finalData
    }
  }

  const onCloseDrawer = () => {
    setDrawerVisible(false)
    setSelectedRowKeys([])
    setPageNum(1)
  }
  const [cutoutPercentage, setCutoutPercentage] = useState(70)
  const [chartDimensions, setChartDimensions] = useState({
    width: 300,
    height: 300,
  })

  useEffect(() => {
    const handleResize = () => {
      const breakpoint = 1500
      const newCutoutPercentage = 65
      const newDimensions = {
        width: window.innerWidth < breakpoint ? 200 : 220,
        height: window.innerWidth < breakpoint ? 200 : 220,
      }
      setChartDimensions(newDimensions)
      setCutoutPercentage(newCutoutPercentage)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const getDoughnutOptions = (id, questionNo, question, answer) => {
    return {
      id: id,

      cutout: cutoutPercentage,
      cutoutPercentage: 80,
      plugins: {
        legend: {
          display: false,
          position: 'bottom',
        },

        datalabels: {
          display: true,
          color: context => {
            const value = context.dataset.data[context.dataIndex]
            return value === 0 ? 'red' : '#fff'
          },
          align: 'center',
          anchor: 'center',
          font: {
            size: 12,
            weight: '600',
          },
          formatter: (value, context) => {
            return context.dataset.data[context.dataIndex] === 0
              ? ''
              : value + '%'
          },
        },
        tooltip: {
          enabled: true,
          displayColors: false,
          bodyColor: '#333',
          bodyFontColor: '#ff5733', // Text color
          intersect: true,

          callbacks: {
            title: () => '',
            label: function (tooltipItem) {
              const candidateCount =
                tooltipItem.dataset.rawData[tooltipItem.dataIndex]
              const label = tooltipItem.label
              setTooltip(label)

              return [
                `${candidateCount} Candidates`,
                `${LabelChange(label).toShow}`,
              ]
            },
            labelTextColor: data => {
              return LabelChange(tooltip).color
            },
          },
          backgroundColor: 'rgba(255, 255, 255, 0.8)', // Tooltip background color
          borderColor: LabelChange(tooltip).color,
          borderWidth: 2, // Border width
          cornerRadius: 5, // Border radius
          padding: 10, // Padding
        },
      },
      customProperty: 'yourCustomValue',

      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 1,

      onClick: async (event, elements) => {
        if (elements.length > 0) {
          let roleId = jobId
          const questionId = id || '1'
          const status = LabelChange(tooltip).status
          let pageNum = 1
          await getIndividualDrawerList({
            roleId,
            questionId,
            status,
            pageNum,
            setLoading,
          })
          setDrawerVisible(true)
          setClear(true)
          setQuestionId(id)
          setQuestionToDisplay({
            questionNo: questionNo,
            question: question,
            answer: answer,
          })
        }
      },
    }
  }

  const defaultCategoryPercentage = 0.7 // Set your default category percentage
  const individualBarWidths = [40, 40, 50, 50, 50] // Set your desired graphList widths

  const onClick = (event, elements) => {}
  const chartLegend = [
    {
      color: '#0FB680',
      status: 'Correct',
    },
    {
      color: '#F54B56',
      status: 'Incorrect',
    },
  ]
  const chartLegendNonMandatory = [
    {
      color: '#0FB680',
      status: 'Correct',
    },
    {
      color: '#F54B56',
      status: 'Incorrect',
    },
    {
      color: '#7F7F7F',
      status: 'Not Answered',
    },
  ]

  const getBarChartOptions = (id, questionNo, question, answer) => {
    return {
      id: id,
      scales: {
        x: {
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true,
          max: 100,
          stepSize: 20,
          ticks: {
            callback: function (value) {
              return value % 20 === 0 ? value : ''
            },
          },
        },
      },
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Custom Chart Title',
          font: {
            size: 18,
          },
        },
        datalabels: {
          display: true,
          color: context => {
            const value = context.dataset.data[context.dataIndex]
            return value === 0 ? 'red' : '#fff'
          },
          align: 'center',
          anchor: 'center',
          font: {
            size: 12,
            weight: '600',
          },
          formatter: (value, context) => {
            return context.dataset.data[context.dataIndex] === 0
              ? ''
              : value + '%'
          },
        },
        tooltip: {
          enabled: true,
          displayColors: false,
          bodyColor: '#333',
          bodyFontColor: '#ff5733', // Text color
          mode: 'index', // Display tooltips only when hovering over bars
          intersect: true, // Make sure tooltips appear on bars
          callbacks: {
            title: () => '',
            label: function (tooltipItem) {
              const candidateCount =
                tooltipItem.dataset.rawData[tooltipItem.dataIndex]
              const label = tooltipItem.label
              setTooltip(label)

              return [
                `${candidateCount} Candidates`,
                `${LabelChange(label).toShow}`,
              ]
            },
            labelTextColor: data => {
              return LabelChange(tooltip).color
            },
          },
          backgroundColor: 'rgba(255, 255, 255, 0.8)', // Tooltip background color
          borderColor: LabelChange(tooltip).color,
          borderWidth: 2, // Border width
          cornerRadius: 5, // Border radius
          padding: 10, // Padding
        },
      },
      onClick: async (event, elements) => {
        if (elements.length > 0) {
          let roleId = jobId
          const questionId = id || '1'
          const status = LabelChange(tooltip).status
          let pageNum = 1
          await getIndividualDrawerList({
            roleId,
            questionId,
            status,
            pageNum,
            setLoading,
          })
          setDrawerVisible(true)
          setClear(true)
          setQuestionId(id)
          setQuestionToDisplay({
            questionNo: questionNo,
            question: question,
            answer: answer,
          })
        }
      },

      maintainAspectRatio: false,
      responsive: true,
      width: 450,
      height: 200,
      barPercentage: 0.1, // Adjust this value to change the bar width
      categoryPercentage: 0.1, // Adjust this value to change the space between bars
      elements: {
        bar: {
          borderRadius: 6, // Adjust the value to control the curvature of the ends
          borderSkipped: 'start', // Set to 'end' to curve only the ends
        },
      },
    }
  }
  return (
    <div>
      {isVisible ? (
        <Row style={{ marginLeft: '-5em' }}>
          {chartData?.map((item, index) => (
            <Col
              md={{
                span: 18,
              }}
              lg={{
                span: 16,
              }}
              xl={{
                span: 7,
                offset: 1,
              }}
              key={index + 'chartData'}
            >
              <IndividualCardContainer key={index + 'chartData'}>
                <CardRow>
                  <IndividualCard>
                    <div style={{ width: '100%' }}>
                      <QuestionDiv>
                        <Question>{`Q${index + 1}.`}</Question>
                        <Question>
                          {item?.question?.questionBank?.rawQuestion?.length >
                          20
                            ? `${item?.question?.questionBank?.question
                                .replace(/<[^>]+>|\s+&nbsp;/g, '')
                                ?.substring(0, 150)}`
                            : item?.question?.questionBank?.question.replace(
                                /<[^>]+>|\s+&nbsp;/g,
                                ''
                              )}
                          {item?.question?.questionBank?.rawQuestion?.length >
                            150 &&
                            !drawerVisible && <SeeMore>...</SeeMore>}
                        </Question>
                      </QuestionDiv>
                      <NoteMessage mandatory={item?.question?.mandatory}>
                        <StyledSpace>
                          {item?.question?.mandatory ? (
                            <>
                              <StyledInfoCircle
                                mandatory={item?.question?.mandatory}
                              />
                              <AlertText mandatory={item?.question?.mandatory}>
                                <span>
                                  {item?.totalCount} Candidates responded for
                                  this
                                </span>
                                <span
                                  style={{
                                    fontWeight: '800',
                                    marginLeft: '4px',
                                    marginRight: '4px',
                                  }}
                                >
                                  Mandatory
                                </span>
                                <span>question</span>
                              </AlertText>
                            </>
                          ) : (
                            <>
                              <StyledInfoCircle
                                mandatory={item?.question?.mandatory}
                              />
                              <AlertText mandatory={item?.question?.mandatory}>
                                {item?.totalCount} Candidates responded for this
                                question
                              </AlertText>
                            </>
                          )}
                        </StyledSpace>
                      </NoteMessage>
                      {item?.question?.questionBank?.questionType ==
                      'MULTIPLE' ? (
                        <>
                          <ChartCard>
                            <Bar
                              style={{ padding: '15px' }}
                              onClick={(event, elements) =>
                                onClick(event, elements)
                              }
                              data={{
                                labels: item?.chart?.labels,
                                datasets: [
                                  {
                                    data: item?.chart?.percentage,
                                    rawData: item?.chart?.data,
                                    backgroundColor: item.chart.backgroundColor,
                                    borderColor: item.chart.borderColor,
                                    borderWidth: 1,
                                    barThickness: individualBarWidths,
                                    categoryPercentage:
                                      defaultCategoryPercentage,
                                  },
                                ],
                              }}
                              options={getBarChartOptions(
                                item?.question?.id,
                                index + 1,
                                item?.question?.questionBank?.question,
                                item?.question?.questionBank?.answer
                              )}
                            />
                          </ChartCard>
                          <AnswerDiv>
                            {item.question.mandatory ? (
                              <>
                                {chartLegend.map((label, i) => (
                                  <AnswerOptions key={i + label?.color}>
                                    <AnswerOptionBackground
                                      style={{
                                        backgroundColor: label.color,
                                      }}
                                    ></AnswerOptionBackground>
                                    <span>{label.status}</span>
                                  </AnswerOptions>
                                ))}
                              </>
                            ) : (
                              <>
                                {chartLegendNonMandatory.map((label, i) => (
                                  <AnswerOptions key={i + label?.color}>
                                    <AnswerOptionBackground
                                      style={{
                                        backgroundColor: label.color,
                                      }}
                                    ></AnswerOptionBackground>
                                    <span>{label.status}</span>
                                  </AnswerOptions>
                                ))}
                              </>
                            )}
                          </AnswerDiv>
                        </>
                      ) : (
                        <>
                          {item?.question?.questionBank?.questionType ==
                          'BINARY' ? (
                            <>
                              <ChartCard mandatory={item.mandatory}>
                                <DoughnutChartAlign>
                                  <Doughnut
                                    style={{
                                      maxWidth: `${chartDimensions.width}px`,
                                      maxHeight: `${chartDimensions.height}px`,
                                      textAlign: 'center',
                                    }}
                                    data={{
                                      labels: item?.chart?.labels,
                                      datasets: [
                                        {
                                          data: item?.chart?.percentage,
                                          rawData: item?.chart?.data,
                                          backgroundColor:
                                            item.chart.backgroundColor,
                                          borderColor: item.chart.borderColor,
                                          borderWidth: 1,
                                        },
                                      ],
                                      originalValue: item?.chart?.data,
                                    }}
                                    options={getDoughnutOptions(
                                      item?.question?.id,
                                      index + 1,
                                      item?.question?.questionBank?.question,
                                      item?.question?.questionBank?.answer
                                    )}
                                  />
                                </DoughnutChartAlign>
                              </ChartCard>
                              <AnswerDiv>
                                {item.question.mandatory ? (
                                  <>
                                    {chartLegend.map((label, i) => (
                                      <AnswerOptions key={i + label?.color}>
                                        <AnswerOptionBackground
                                          style={{
                                            backgroundColor: label.color,
                                          }}
                                        ></AnswerOptionBackground>
                                        <span>{label.status}</span>
                                      </AnswerOptions>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    {chartLegendNonMandatory.map((label, i) => (
                                      <AnswerOptions key={i + label?.color}>
                                        <AnswerOptionBackground
                                          style={{
                                            backgroundColor: label.color,
                                          }}
                                        ></AnswerOptionBackground>
                                        <span>{label.status}</span>
                                      </AnswerOptions>
                                    ))}
                                  </>
                                )}
                              </AnswerDiv>
                            </>
                          ) : (
                            <ChartCard>
                              <EmptyMessage> No candidates found</EmptyMessage>
                            </ChartCard>
                          )}
                        </>
                      )}
                    </div>
                  </IndividualCard>
                </CardRow>
              </IndividualCardContainer>
            </Col>
          ))}
        </Row>
      ) : (
        <OverViewText style={{ display: 'flex', justifyContent: 'center' }}>
          At present, there have been no applicants for this role
        </OverViewText>
      )}
      <QuestionWithSeeMore
        setCountDriveSummary={setCountDriveSummary}
        countDriveSummary={countDriveSummary}
        setClear={setClear}
        clear={clear}
        loading={loading}
        setLoading={setLoading}
        drawerVisible={drawerVisible}
        onClose={onCloseDrawer}
        labels={tooltip}
        questionToDisplay={questionToDisplay}
        individualDrawerQuestion={individualDrawerQuestion}
        getIndividualDrawerList={getIndividualDrawerList}
        roleId={jobId}
        status={LabelChange(tooltip).status}
        questionId={questionId}
        setSelectedRowKeys={setSelectedRowKeys}
        selectedRowKeys={selectedRowKeys}
        pageNum={pageNum}
        singleRoleData={singleRoleData}
        getCandidateDetails={getCandidateDetails}
        getPromotion={getPromotion}
        promotionData={promotionData}
        candidateDetails={candidateDetails}
        setPageNum={setPageNum}
        getQuestionAndAnswerList={getQuestionAndAnswerList}
      />
    </div>
  )
}

export default Individualindex
